// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Tg","title":"e_Ug","wavy":"e_Vg","navLink":"e_Wg","active":"e_Xg","iconArrow":"e_Yg"};